import { render, staticRenderFns } from "./config-toggle-slider.vue?vue&type=template&id=4bfe1717"
import script from "./config-toggle-slider.vue?vue&type=script&lang=js"
export * from "./config-toggle-slider.vue?vue&type=script&lang=js"
import style0 from "./config-toggle-slider.vue?vue&type=style&index=0&id=4bfe1717&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports